<template>
  <div class="simple-thumb">
    <span class="wrap">
      <span class="figure">
        <slot name="icon"/>
      </span>
      <span class="text">
        <slot name="link"/>
      </span>
    </span>
  </div>
</template>

<script>
  export default {
    name: "Category"
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles.scss';
  @import './card-style.scss';
</style>